/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'typeexl': {
    width: 200,
    height: 233.186,
    viewBox: '0 0 200 233.186',
    data: '<g fill-rule="evenodd"><path pid="0" d="M200 196.39V61.84c0-8.29-3.29-16.24-9.15-22.1L160.26 9.15A31.252 31.252 0 00138.16 0H36.8C16.47 0 0 16.48 0 36.8v159.59c0 20.32 16.48 36.8 36.8 36.8h126.4c20.33 0 36.8-16.48 36.8-36.8z" _fill="#5acc9b"/><path pid="1" d="M160.258 9.156a31.222 31.222 0 00-16.08-8.57v34.34c0 10.9 8.84 19.74 19.74 19.74h35.24a31.224 31.224 0 00-8.31-14.92l-30.59-30.59z" _fill="#bdebd7"/></g><path pid="2" fill-rule="evenodd" d="M99.8 134.593l19.6 28.8h19l-29.2-40.4 27.8-38h-18.2l-18.6 27.2-17.8-27.2H63.6l27.2 38-29.2 40.6h18.6l19.6-29z" _fill="#fff"/>'
  }
})
